import { Instance } from 'mobx-state-tree';
import { RouteTimelineViolationDtoModelBase } from './RouteTimelineViolationDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineViolationDtoModel */
export interface RouteTimelineViolationDtoModelType extends Instance<typeof RouteTimelineViolationDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineViolationDtoModel */
export { selectFromRouteTimelineViolationDto, routeTimelineViolationDtoModelPrimitives, RouteTimelineViolationDtoModelSelector } from './RouteTimelineViolationDtoModel.base';

/**
 * RouteTimelineViolationDtoModel
 */
export const RouteTimelineViolationDtoModel = RouteTimelineViolationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
